import Header from './header';
import { SIZE } from './constants';

export default Header;
export { SIZE };
